module.exports = __webpack_public_path__ + "img/Family-Living.5da970ab.png";